export default __webpack_public_path__ + "static/media/home.bf22060c.svg";